import React, { useContext } from 'react'
import ErrorMessage from 'app/React/Components/misc/ErrorMessage'
import PropTypes from 'prop-types'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function EnvInput(props) {
  const {
    errors,
    order,
    setErrors,
    setOrder,
    defaultValidateSteps
  } = useContext(ConfiguratorContext)

  const { name, extraOnChange = (e) => {} } = props
  const allProps = { ...props }

  if (allProps.hasOwnProperty('extraOnChange')) {
    delete allProps.extraOnChange
  }

  const onChange = (e) => {
    order[name] = e.target.value
    setOrder({ ...order })

    const { [name]: _, ..._errors } = errors

    setErrors(_errors)

    if (typeof props.onChange === 'function') {
      props.onChange(e)
    }

    defaultValidateSteps()
    extraOnChange(e)
  }

  return (
    <>
      <input type={props.type} {...allProps} defaultValue={order[name]} name={name} id={name} onChange={onChange}/>
      {props.required === true ? <ErrorMessage field={name}/> : null}
    </>
  )
}

EnvInput.defaultProps = {
  required: true,
  type: 'text'
}

EnvInput.propTypes = {
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  required: PropTypes.bool
}
